import { render, staticRenderFns } from "./ProjectRow.vue?vue&type=template&id=9a77683a"
import script from "./ProjectRow.vue?vue&type=script&lang=ts"
export * from "./ProjectRow.vue?vue&type=script&lang=ts"
import style0 from "./ProjectRow.vue?vue&type=style&index=0&id=9a77683a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports